import React from 'react';
import TextFieldPopper from '@contentlab/components/text-field-popper';
import translate from '@/utils/translate';

interface CustomGoalTextFieldProps {
  testID?: string;
  open: boolean;
  anchorEl: HTMLElement | null;
  onClose: () => void;
  onSubmit: (customGoal: string) => void;
  initialValue?: string;
  controlled?: boolean;
}

function CustomGoalTextField({
  testID = 'custom-goal-text-field',
  open,
  anchorEl,
  onClose,
  onSubmit,
  initialValue = '',
  controlled = false,
}: CustomGoalTextFieldProps) {
  return (
    <TextFieldPopper
      testID={testID}
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      onSubmit={onSubmit}
      initialValue={initialValue}
      placeholder={translate('describe-your-goal-placeholder')}
      controlled={controlled}
    />
  );
}

export default CustomGoalTextField;
